import { createContext, ReactNode, useContext, useState } from 'react';

type ScreenData = {
  screen: string;
  updateScreen: (data: string) => void;
};

export const ScreenContext = createContext({} as ScreenData);

type ScreenProviderData = {
  children: ReactNode;
};

export function ScreenProvider({ children }: ScreenProviderData) {
  const [screen, setScreen] = useState<string>('token');

  async function updateScreen(data: string) {
    setScreen(data);
  }

  return (
    <ScreenContext.Provider value={{ screen, updateScreen }}>
      {children}
    </ScreenContext.Provider>
  );
}

export const useScreen = (): ScreenData => {
  const context = useContext(ScreenContext);

  if (!context) {
    throw new Error(`useScreen must be use within a ScreenProvider!`);
  }

  return context;
};
